import HttpReq from '../../service/httpReq';

export type RelationsResponseType = {
    categoryId: number;
    categoryName: string;
    schemaRelations: {
        companyId: number;
        companyName: string;
        descriptors: { descriptorLabel: string }[];
        schemaId: number;
        schemaName: string;
    }[];
}[];

class CategoriesRelationsRepo {
    static publicPath = 'api/financial-category-relations';
    static cacheKey = 'relations';
    static cache: Record<string, RelationsResponseType> = {};

    static getRelations(
        successConsumer: (response: RelationsResponseType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        const cache = CategoriesRelationsRepo.cache;
        const cacheKey = CategoriesRelationsRepo.cacheKey;
        if (!cache[cacheKey]) {
            HttpReq.get(
                CategoriesRelationsRepo.publicPath,
                (relations: RelationsResponseType) => {
                    cache[cacheKey] = relations;
                    successConsumer(relations);
                },
                errorConsumer
            );
        } else {
            successConsumer(CategoriesRelationsRepo.cache[CategoriesRelationsRepo.cacheKey]);
        }
    }
}

export default CategoriesRelationsRepo;
